import React, { useCallback, useMemo } from 'react';
import { Col, Drawer, List as AList, Row, Empty } from 'antd';
import styled from 'styled-components';
import { StyledTitle as Title } from '../../../fields/Title';
import { TutorGroupStudentsListItem } from '../create-tutor-group/TutorGroupStudentsListItem';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';

const StyledDivider = styled.div`
  width: 100%;
  height: 1px;
  margin: 10px 0;
`;

const StyledEmptyDescription = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const StyledSubtitle = styled.span`
  display: inline-block;
  width: 100%;
  font-size: 14px;
  color: #000000;
  margin-bottom: 15px;
`;

export const StudentEnrollmentsDrawer = ({
  studentEnrollments = [],
  unEnrolledStudents = [],
  onClose,
  visible,
  remove,
  push
}) => {
  const currentClassDiffStudents = useMemo(() => {
    let filteredStudents = [];

    unEnrolledStudents?.forEach((student) => {
      const foundStudent = studentEnrollments?.find(
        ({ id }) => id === student.id
      );

      if (foundStudent) {
        filteredStudents = [...filteredStudents];
      } else {
        filteredStudents = [...filteredStudents, student];
      }
    });

    return filteredStudents;
  }, [studentEnrollments, unEnrolledStudents]);

  const addStudentOnClick = useCallback(
    ({ event, student }) => {
      console.log('addStudentOnClick, event: ', event);
      event.preventDefault();
      event.stopPropagation();

      push(student);
    },
    [push]
  );

  const removeStudentOnClick = useCallback(
    ({ event, student, index }) => {
      console.log('removeStudentOnClick, event: ', event);
      console.log('removeStudentOnClick, student: ', student);

      event.preventDefault();
      event.stopPropagation();

      remove(index);
    },
    [remove]
  );

  return (
    <Drawer
      title={<FormattedMessage id="classes-dashboard.drawer1.studentEnrollments" />}
      placement='right'
      width={window.innerWidth > 500 ? 500 : window.innerWidth}
      onClose={onClose}
      visible={visible}
    >
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
        <Col xl={24}>
          <Title level={5}><FormattedMessage id="classes-dashboard.drawer1.currentClassEnrollments" /></Title>
          <StyledSubtitle>
            {studentEnrollments?.length ?? '0'} / 25 <FormattedMessage id="classes-dashboard.drawer1.studentsEnrolled" />
          </StyledSubtitle>
          <AList
            itemLayout='horizontal'
            dataSource={studentEnrollments}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <StyledEmptyDescription>
                      <span> <FormattedMessage id="classes-dashboard.emptyState.noStudents" /></span>
                      <FormattedMessage id="classes-dashboard.emptyState.addStudent" />
                    </StyledEmptyDescription>
                  }
                />
              )
            }}
            renderItem={(student, index) => (
              <TutorGroupStudentsListItem
                student={student}
                index={index}
                onClick={removeStudentOnClick}
                icon={<MinusOutlined />}
              />
            )}
          />
        </Col>
      </Row>
      <StyledDivider />
      <Row gutter={[{ xs: 8, sm: 16, md: 24, lg: 32 }, 16]}>
        <Col xl={24}>
          <Title level={5}><FormattedMessage id="classes-dashboard.drawer1.allStudents" /></Title>
          <StyledSubtitle>
            {currentClassDiffStudents?.length ?? '0'}  <FormattedMessage id="classes-dashboard.drawer1.availableStudents" />
          </StyledSubtitle>
          <AList
            itemLayout='horizontal'
            dataSource={currentClassDiffStudents}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={
                    <StyledEmptyDescription>
                      <span>
                        <FormattedMessage id="classes-dashboard.emptyState.noStudentToAdd" />
                      </span>
                    </StyledEmptyDescription>
                  }
                />
              )
            }}
            renderItem={(student, index) => (
              <TutorGroupStudentsListItem
                student={student}
                index={index}
                count={studentEnrollments?.length}
                maxCount={3}
                onClick={addStudentOnClick}
                icon={<PlusOutlined />}
              />
            )}
          />
        </Col>
      </Row>
    </Drawer>
  );
};
